/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'ngx-app',
  template: '<ngx-notifications></ngx-notifications><router-outlet></router-outlet>',
})
export class AppComponent {

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts